<template>
  <header>
      <div class="container">
          <div class="row">
              <div class="col-12">
                <img src="../assets/logo.png" class="img-fluid" alt="Online ADA">
              </div>
          </div>
      </div>
  </header>
</template>

<script>
export default {
  name: 'Header',
  props: {
  }
}
</script>
<style scoped>
header {
    min-height: 72px;
    padding-top: 10px;
    padding-bottom: 10px;
    background-image: url('../assets/headerbkgd.gif');
    background-size: contain;
    background-repeat: repeat;
}
</style>
